/**
 * Rounds the given value to a maximum number of decimal places.
 */
const numberToFixed = (value, digits = 2) => +value.toFixed(digits)

export { numberToFixed }
